import BaseConverter from './BaseConverter'
import { ToHTMLConverter, middlewares } from '../util/toHTML'

import { sanitizeText, createEmptyBlock } from '../util/draftUtils'

export default class BlockQuoteConverter extends BaseConverter {
  constructor() {
    super('blockquote', ['blockquote'])
    this._htmlConverter = new ToHTMLConverter()
    this._htmlConverter.addMiddleware(
      new middlewares.HighlightToHTMLConverterMiddleware()
    )
    this._htmlConverter.addDefaultMiddleware()
  }

  appendAndGetBlocks(element = {}, context) {
    const blocksFromHTML = context.toDraftBlock(
      `<blockquote>${sanitizeText(element.content)}</blockquote>`,
      element,
      [createEmptyBlock('blockquote')]
    )
    return context.appendBlock(blocksFromHTML.contentBlocks)
  }

  toAnsDataFromBlocks(contentState, [block]) {
    return {
      type: this.getAnsType(),
      content: this._htmlConverter.convert(block, true),
    }
  }
}
